import { render, staticRenderFns } from "./RunsListComponent.vue?vue&type=template&id=7867ddfe&"
import script from "./RunsListComponent.vue?vue&type=script&lang=js&"
export * from "./RunsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports